export default __webpack_public_path__ + "static/media/Venturer's Harness of the Untamed.e6e332e3.jpg";